module.exports = __webpack_public_path__ + "static/media/Test31.1b0a49ab.bmp";